module.exports = __webpack_public_path__ + "static/img/wei.1745385299907.png";